/**
 * The one percent-change formatter for the CSM space: "−37%", "+1,275%", "n/a".
 * A real −100% only happens when the current value is exactly zero. A drop that
 * only ROUNDS to 100 (Akkuro: 1,627 tokens against 190.2M, −99.9991%) reads
 * "<−99%", so a company still using the product never shows "−100%".
 */
export function formatPctChange(pct: number | null | undefined): string {
  if (pct === null || pct === undefined || !Number.isFinite(pct)) return 'n/a';
  const abs = Math.round(Math.abs(pct));
  if (pct < 0 && abs >= 100 && pct > -100) return '<−99%';
  const sign = abs === 0 ? '' : pct > 0 ? '+' : '−';
  return `${sign}${abs.toLocaleString('en-US', { maximumFractionDigits: 0 })}%`;
}

/**
 * A drop the API rounded to −100 while the current value is still above zero
 * (an API from before round H sends −100 for 1,627 tokens against 190.2M) is
 * nudged to −99.9, so it reads "<−99%". Leaves every other value untouched.
 */
export function clampDrop(pct: number | null, current: number | null | undefined): number | null {
  if (pct === null || current === null || current === undefined) return pct;
  return current > 0 && pct <= -100 ? -99.9 : pct;
}
